import { useEffect, useRef } from 'react';
import _ from 'lodash';

import usePropsCallback from './usePropsCallback';

/**
 * Call onChange function as a side effect every time the content of value changes.
 *
 * @param {*} value the watched value
 * @param {function} onChange callback function (newValue, oldValue) => void
 */
const useValueChangeEffect = (value, onChange) => {
  const oldValue = useRef(value);
  const change = useRef();
  const callback = usePropsCallback(onChange);

  useEffect(() => {
    if (change.current) {
      try {
        callback(change.current.newValue, change.current.oldValue);
      } finally {
        change.current = null;
      }
    }
  });

  if (!_.isEqual(value, oldValue.current)) {
    change.current = { oldValue: oldValue.current, newValue: value };
    oldValue.current = _.cloneDeep(value);
  }
};

export default useValueChangeEffect;
